import React from 'react'
import { createPortal } from 'react-dom'
import format from '@st-operations/uikit/lib/format'

import useSidePanel from '../side-panel/index.jsx'
import { CALCULATION_METHODS } from '../geo/index.jsx'
import IconListLoader from '_components/icon-list-loader/index.jsx'

import './styles.scss'

function twoDecimals(n) {
  let log10 = n ? Math.floor(Math.log10(n)) : 0,
    div = log10 < 0 ? Math.pow(10, 1 - log10) : 100

  return Math.round(n * div) / div
}

const GeoSideBar = ({ loading, ranking, topTitle, calculationMethod }) => {
  const { containerRef, Container } = useSidePanel()

  let scoreKey
  if (calculationMethod === CALCULATION_METHODS.EVENTS) {
    scoreKey = 'size'
  } else if (calculationMethod === CALCULATION_METHODS.PER_CAPITA) {
    scoreKey = 'perCapitaScore'
  } else if (calculationMethod === CALCULATION_METHODS.INDEX) {
    scoreKey = 'indexScore'
  } else if (calculationMethod === CALCULATION_METHODS.UNIQUE_USERS) {
    scoreKey = 'users'
  }

  return (
    containerRef &&
    createPortal(
      <Container key="side-panel-container-geo" className="geo-sidebar" startOpen>
        <div className="geo-sidebar__main">
          <section className="geo-sidebar__ranking">
            <h3>Top {topTitle}</h3>
            <If condition={!loading}>
              <ol className="geo-sidebar__ranking-list">
                <For
                  each="item"
                  of={ranking
                    .filter((f, index) => index < 200)
                    .sort((i1, i2) => (i1[scoreKey] < i2[scoreKey] ? 1 : -1))}
                  index="index"
                >
                  <li key={`ranking-${index}`} className="geo-sidebar__ranking-list-item">
                    <p className="geo-sidebar__ranking-list-item-text">
                      {item.name}
                      {item.state ? `, ${item.state}` : ''}{' '}
                      {item[scoreKey] < 1000
                        ? twoDecimals(item[scoreKey])
                        : format('metric', item[scoreKey])}
                    </p>
                  </li>
                </For>
              </ol>
            </If>
            <If condition={loading}>
              <IconListLoader className="geo-sidebar__ranking" />
            </If>
          </section>
        </div>
      </Container>,
      containerRef
    )
  )
}

export default GeoSideBar
